import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _ForexManagementFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M22 15C22.5523 15 23 15.4477 23 16C23 20.4223 19.4223 24 15 24C14.6399 24 14.3074 23.8064 14.1299 23.4932C13.9524 23.1797 13.9572 22.7943 14.1426 22.4854L15.1924 20.7354C15.4765 20.2618 16.0909 20.1084 16.5645 20.3926C17.0087 20.6591 17.1711 21.2159 16.9551 21.6748C19.3106 20.8653 21 18.6329 21 16C21 15.4477 21.4477 15 22 15Z"
        fill={iconColor}
      />
      <Path
        d="M10 20.8467C9.99976 22.4785 8.20899 23.7998 6 23.7998C3.79101 23.7998 2.00024 22.4785 2 20.8467V19.501C2.22688 19.772 2.47715 20.0085 2.74609 20.2051C3.62151 20.8512 4.77376 21.2158 6 21.2158C7.22629 21.2158 8.37848 20.851 9.25391 20.2041C9.51902 20.0092 9.77373 19.7734 10 19.501V20.8467Z"
        fill={iconColor}
      />
      <Path
        d="M6 14.2002C8.20914 14.2002 10 15.5223 10 17.1543C9.99981 18.7862 8.20903 20.1074 6 20.1074C3.79097 20.1074 2.00019 18.7862 2 17.1543C2 15.5223 3.79086 14.2002 6 14.2002Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 1C18.0523 1 18.5 1.44772 18.5 2V3H20.417C20.9691 3.00018 21.417 3.44782 21.417 4C21.417 4.55218 20.9691 4.99982 20.417 5H18.5V6.5H18.958C19.7191 6.5 20.4747 6.75756 21.0527 7.25293C21.6356 7.75251 22 8.46654 22 9.25C22 10.0335 21.6356 10.7475 21.0527 11.2471C20.4747 11.7424 19.7191 12 18.958 12H18.5V13C18.5 13.5523 18.0523 14 17.5 14C16.9477 14 16.5 13.5523 16.5 13V12H14C13.4477 12 13 11.5523 13 11C13 10.4477 13.4477 10 14 10H16.5V8.5H16.042C15.2809 8.5 14.5253 8.24244 13.9473 7.74707C13.3644 7.24749 13 6.53346 13 5.75C13 4.96654 13.3644 4.25251 13.9473 3.75293C14.5253 3.25756 15.2809 3 16.042 3H16.5V2C16.5 1.44772 16.9477 1 17.5 1ZM18.5 10H18.958C19.2796 10 19.5633 9.88926 19.751 9.72852C19.9339 9.57172 20 9.3948 20 9.25C20 9.1052 19.9339 8.92828 19.751 8.77148C19.5633 8.61074 19.2796 8.5 18.958 8.5H18.5V10ZM16.042 5C15.7204 5 15.4367 5.11074 15.249 5.27148C15.0661 5.42828 15 5.6052 15 5.75C15 5.8948 15.0661 6.07172 15.249 6.22852C15.4367 6.38926 15.7204 6.5 16.042 6.5H16.5V5H16.042Z"
        fill={iconColor}
      />
      <Path
        d="M9 2C9.36012 2 9.69256 2.19356 9.87012 2.50684C10.0476 2.82034 10.0428 3.20572 9.85742 3.51465L8.80762 5.26465C8.52345 5.73818 7.90911 5.89155 7.43555 5.60742C6.99133 5.34089 6.82887 4.78408 7.04492 4.3252C4.68939 5.13473 3 7.36709 3 10C3 10.5523 2.55228 11 2 11C1.44772 11 1 10.5523 1 10C1 5.57772 4.57772 2 9 2Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const ForexManagementFilledIcon = assignWithoutSideEffects(_ForexManagementFilledIcon, {
  componentId: 'ForexManagementFilledIcon',
});

export default ForexManagementFilledIcon;
